const getScaledNumber = (inputX: number, inputY: number, outputY: number) => {
  let outputX = 0
  outputX = (outputY * inputX) / inputY

  return outputX
}

export const getScaledSize = (
  imageWidth: number,
  imageHeight: number,
  containerWidth: number,
  containerHeight: number
) => {
  const baseContainerWidth = containerWidth <= containerHeight ? containerWidth : undefined
  const baseContainerHeight = containerHeight <= containerWidth ? containerHeight : undefined
  let widthAdjusted = 0
  let heightAdjusted = 0

  if (baseContainerHeight) {
    // If Image is tall
    heightAdjusted = baseContainerHeight
    widthAdjusted = getScaledNumber(baseContainerHeight, imageHeight, imageWidth)

    if (widthAdjusted > containerWidth) {
      // Resize scaled image if it's still larger than container
      heightAdjusted = getScaledNumber(containerWidth, widthAdjusted, heightAdjusted)
      widthAdjusted = containerWidth
    }
  } else if (baseContainerWidth) {
    // If Image is wide
    widthAdjusted = baseContainerWidth
    heightAdjusted = getScaledNumber(baseContainerWidth, imageWidth, imageHeight)

    if (heightAdjusted > containerHeight) {
      // Resize scaled image if it's still larger than container
      widthAdjusted = getScaledNumber(containerHeight, heightAdjusted, widthAdjusted)
      heightAdjusted = containerHeight
    }
  }

  return [widthAdjusted || 0, heightAdjusted || 0]
}
